import { Avatar, Column, Row, Tag, Text } from 'farmhub-ui-core';

import CopyPhone from 'components/CopyPhone';
import { theme } from 'styled';
import { formatAppearPhoneNumber, formatImageUrl, IMAGETYPE } from 'utils';

import { AccountInformationItemInterface } from './interfaces';
import { AccountInformationItemWrapper } from './styles';

type AccountInformationItemProps = {
  data: AccountInformationItemInterface;
  isPrint?: boolean;
};

const AccountInformationItem = ({
  data,
  isPrint = false,
}: AccountInformationItemProps) => (
  <AccountInformationItemWrapper isPrint={isPrint}>
    <Avatar
      size={theme.avatar.size.md}
      src={formatImageUrl(data.avatar, IMAGETYPE.AVATAR.xxs)}
    />
    <Column styles={{ gap: 4 }}>
      <Row styles={{ gap: 6 }}>
        <Text color={isPrint ? 'black' : 'main'} weight="bold">
          {data.name}
        </Text>
        {data?.role &&
          (isPrint ? (
            <Text color="black" weight="medium">
              ({data.role})
            </Text>
          ) : (
            <Tag
              color="#f50"
              styles={{
                fontSize: '11px',
                lineHeight: '18px',
                ...(isPrint ? { color: '#000000' } : {}),
              }}
            >
              {data.role}
            </Tag>
          ))}
      </Row>
      <Text color={isPrint ? 'black' : 'secondary'} weight="medium">
        {data.address}
      </Text>
      {isPrint ? (
        <Text color={isPrint ? 'black' : 'secondary'} weight="medium">
          {formatAppearPhoneNumber(data.phoneNumber)}
        </Text>
      ) : (
        <CopyPhone phoneNumber={data.phoneNumber} />
      )}
    </Column>
  </AccountInformationItemWrapper>
);

export default AccountInformationItem;
